import {Component} from '@angular/core';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {PodcastService} from '../../services/podcast.service';
import {map} from 'rxjs/operators';

type Podcast = {
    author: string;
    categories: string[];
    content: string;
    description: string;
    guid: string;
    link: string;
    pubDate: string;
    thumbnail: string;
    title: string;
}

@Component({
    selector: 'angular-community-podcast',
    template: `
        <div class="wrapper" *ngFor="let podcast of podcasts$ | async">
            <iframe [src]="getSafeUrl(podcast.guid)" width="100%" height="200px"></iframe>
        </div>
    `,
    styles: [
        `
            :host {
                padding: 0 2em;
                box-sizing: border-box;
            }
            
            .wrapper {
                max-width: 800px;
                display: flex;
                flex-direction: column;
                margin: 0 auto;
            }

            iframe {
                margin-bottom: 4em;
            }
        `
    ]
})
export class PodcastComponent {
    private readonly urlStart = 'https://widget.spreaker.com/player?episode_id=';
    private readonly urlEnd = '&theme=dark&autoplay=false&playlist=false&cover_image_url=https%3A%2F%2Fd3wo5wojvuv7l.cloudfront.net%2Fimages.spreaker.com%2Foriginal%2Ff3a1b8b5a1b8b5a1b8b5a1b8b5a1b8b5.jpg';
    podcasts$ = this.podcasts.getPodcasts().pipe(
        map(({items}) => items),
        devLifeFilter(),
    );

    getSafeUrl(guid: string) {
        const episodeId = guid.split('/').pop();
        return this.sanitizer.bypassSecurityTrustResourceUrl(`${this.urlStart}${episodeId}${this.urlEnd}`);
    }

    constructor(
        private titleService: Title,
        private podcasts: PodcastService,
        private sanitizer: DomSanitizer,
    ) {
        this.titleService.setTitle('Angular Community Meetup | Podcast');
    }
}

function devLifeFilter() {
    return map((items: Podcast[]) => {
        return items.filter(({title}) => title.includes('The Dev Life'));
    });
}